import { colors, lineHeights, fontWeights } from "./";
import components from './components';
import config from './config';
export var breakpoints = ['576px', '992px', '1200px', '1300px'];
var theme = {
    breakpoints: breakpoints,
    colors: colors,
    components: components,
    config: config,
    fonts: {
        primary: 'MiloOT',
        secondary: 'Lovelace',
        tertiary: 'LovelaceText',
    },
    fontSizes: [
        '0.75rem',
        '0.875rem',
        '1rem',
        '1.125rem',
        '1.25rem',
        '1.375rem',
        '1.813rem',
    ],
    fontWeights: fontWeights,
    lineHeights: lineHeights,
    radii: [24, 25, 28, 33, 34, 38],
    space: [
        '0',
        '0.5rem',
        '0.75rem',
        '1rem',
        '1.5rem',
        '1.75rem',
        '2rem',
        '2.5rem',
        '3rem',
        '3.5rem',
        '3.875rem',
        '4.375rem',
        '4.5rem',
        '5rem',
        '6rem',
        '12rem',
        '13rem',
    ],
};
theme.fontSizes.extraTiny = theme.fontSizes[0];
theme.fontSizes.tiny = theme.fontSizes[1];
theme.fontSizes.small = theme.fontSizes[2];
theme.fontSizes.normal = theme.fontSizes[3];
theme.fontSizes.medium = theme.fontSizes[4];
theme.fontSizes.large = theme.fontSizes[5];
theme.fontSizes.extraLarge = theme.fontSizes[6];
theme.space.extraTiny = theme.space[1];
theme.space.tiny = theme.space[2];
theme.space.small = theme.space[3];
theme.space.normal = theme.space[4];
theme.space.medium = theme.space[5];
theme.space.large = theme.space[6];
theme.space.extraLarge = theme.space[7];
export default theme;
//# sourceMappingURL=theme.js.map